import React, { useState, useEffect } from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import TeamSection from './TeamSection';
import RoomsSection from './RoomsSection';
import ReviewsSection from './ReviewsSection';
import ContactSection from './ContactSection';
import MapSection from './MapSection';
import Footer from './Footer';
import './LandingPage.css';

const LandingPage = () => {
  const [activeSection, setActiveSection] = useState('inicio');
  const [siteData, setSiteData] = useState(null);

  useEffect(() => {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
    fetch(`${BACKEND_URL}/api/content.php`)
      .then(res => res.json())
      .then(data => setSiteData(data))
      .catch(err => console.error('Error loading site content:', err));
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['inicio', 'servicios', 'equipo', 'salas', 'contacto'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!siteData) return null;

  const { services, team, rooms, reviews, settings } = siteData;

  return (
    <div className="landing-page">
      <div className="background-blobs">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
      </div>
      <Header activeSection={activeSection} settings={settings} />
      <HeroSection settings={settings} />
      <ServicesSection services={services} />
      <TeamSection team={team} settings={settings} />
      <ReviewsSection reviews={reviews} />
      <RoomsSection rooms={rooms} />
      <ContactSection />
      <MapSection settings={settings} />
      <Footer settings={settings} services={services} />
    </div>
  );
};

export default LandingPage;
